import React, { createContext, useContext, useState } from 'react';

const ParentContext = createContext(null);

export const ParentProvider = ({ children }) => {
  const [parent, setParent] = useState(null);

  return (
    <ParentContext.Provider value={{ parent, setParent }}>
      {children}
    </ParentContext.Provider>
  );
};

export const useParent = () => {
  const context = useContext(ParentContext);

  if (!context) {
    return { parent: null, setParent: () => {} };
  }

  return context;
};
